export default "__VITE_ASSET__Djieoa9n__"